import { useTranslation } from 'react-i18next';

import { Box, Button } from '@mui/material';

import { Add } from '@mui/icons-material';
import { DialogTypes } from 'types/types';
import { useSetRecoilState } from 'recoil';
import { dialogState } from 'state';
import useHasAccess from 'hooks/useHasAccess';
import { Permission } from 'state/permissionState';

export function PatientsBar() {
  const { t } = useTranslation();
  const openDialog = useSetRecoilState(dialogState);
  const canCreatePatient = useHasAccess([Permission.WRITE_PATIENT]);

  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      flexDirection="row"
      justifyContent="end"
    >
      <Button
        size="small"
        variant="contained"
        sx={{ mr: 1 }}
        disabled={!canCreatePatient}
        startIcon={<Add />}
        onClick={() =>
          openDialog({ isOpen: true, dialogType: DialogTypes.addPatient })
        }
      >
        {t('home.appBar.createNewPatient')}
      </Button>
    </Box>
  );
}
